import { useLayoutEffect } from "react";

export function useRegisterHeightToCSS(
  ref: React.RefObject<HTMLElement>,
  cssProperty: string,
) {
  useLayoutEffect(() => {
    if (!ref.current) return;

    const el = ref.current;
    const height = el.offsetHeight;

    document.documentElement.style.setProperty(cssProperty, `${height}px`);

    // Cleanup on unmount
    return () => {
      document.documentElement.style.removeProperty(cssProperty);
    };
  }, [ref, cssProperty]);
}
